/**
 * Collection Product Grid – product card swatches (same behavior as Find Right Ride cards)
 */
(function () {
  'use strict';

  function selectVariant(card, swatch) {
    const variantId = swatch.getAttribute('data-variant-id');
    const imageUrl = swatch.getAttribute('data-variant-image');
    const productUrl = swatch.getAttribute('data-variant-url');
    const priceFormatted = swatch.getAttribute('data-variant-price-formatted');
    const compareFormatted = swatch.getAttribute('data-variant-compare-formatted');
    const saveLabel = swatch.getAttribute('data-variant-save-label');
    const savePercent = swatch.getAttribute('data-variant-save-percent');
    const available = swatch.getAttribute('data-variant-available') === 'true';

    card.querySelectorAll('[data-frr-swatch]').forEach((btn) => {
      btn.classList.toggle('is-active', btn === swatch);
    });

    const input = card.querySelector('[data-frr-variant-input]');
    if (input && variantId) input.value = variantId;

    const wishlist = card.querySelector('[data-frr-wishlist]');
    if (wishlist && variantId) wishlist.setAttribute('data-variant-id', variantId);

    const image = card.querySelector('[data-frr-image]');
    if (image && imageUrl) {
      image.src = imageUrl;
      image.removeAttribute('srcset');
    }

    const imageLink = card.querySelector('[data-frr-image-link]');
    const titleLink = card.querySelector('[data-frr-title-link]');
    if (productUrl) {
      if (imageLink) imageLink.href = productUrl;
      if (titleLink) titleLink.href = productUrl;
    }

    const priceEl = card.querySelector('[data-frr-price]');
    if (priceEl && priceFormatted) priceEl.textContent = priceFormatted;

    const compareEl = card.querySelector('[data-frr-compare]');
    if (compareEl) {
      if (compareFormatted) {
        compareEl.textContent = compareFormatted;
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    const saveBadge = card.querySelector('[data-frr-save-badge]');
    const saveLabelEl = card.querySelector('[data-frr-save-label]');
    const savePercentEl = card.querySelector('[data-frr-save-percent]');
    const offerEl = card.querySelector('[data-frr-offer]');

    if (saveBadge && saveLabelEl && savePercentEl) {
      if (saveLabel && savePercent) {
        saveLabelEl.textContent = saveLabel;
        savePercentEl.textContent = savePercent;
        saveBadge.hidden = false;
        if (offerEl) offerEl.hidden = false;
      } else {
        saveBadge.hidden = true;
        if (offerEl) offerEl.hidden = true;
      }
    }

    const atc = card.querySelector('[data-frr-atc]');
    if (atc) {
      atc.disabled = !available;
      atc.textContent = available ? 'Add to Cart' : 'Sold Out';
    }
  }

  function initCards(root) {
    root.querySelectorAll('[data-frr-card]').forEach((card) => {
      if (card.dataset.frrCardReady === 'true') return;
      card.dataset.frrCardReady = 'true';

      card.querySelectorAll('[data-frr-swatch]').forEach((swatch) => {
        swatch.addEventListener('click', () => selectVariant(card, swatch));
      });
    });
  }

  function initSection(sectionEl) {
    const root = sectionEl.querySelector('[data-collection-product-grid]');
    if (!root || root.dataset.cpgReady === 'true') return;
    root.dataset.cpgReady = 'true';
    initCards(root);
  }

  function initAll() {
    document.querySelectorAll('.collection-product-grid-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (section.classList.contains('collection-product-grid-section')) {
      const root = section.querySelector('[data-collection-product-grid]');
      if (root) root.dataset.cpgReady = 'false';
      initSection(section);
    }
  });
})();
